import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import { S3_URL } from "../services/Constants";
import { userRoleManagementHeadCells } from "../util/headcells-util";
import _ from "lodash";
import { handleIsActive } from "../util/common";
import moment from "moment";
import {
  fetchUsersData,
  fetchUserById,
  fetchRolesData,
  updateUserRecord,
} from "../services/users-service";
import Cookies from "js-cookie";
import { validateAndSanitizeUrl } from "../util/common";

const UserRoleManagement = () => {
  const [show, setShow] = useState(false);
  const [form, setForm] = useState({});
  const [validated, setValidated] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [alertMessage, setAlertMessage] = useState();
  const [selectedRow, setSelectedRow] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(Cookies.get("itemsPerPage")?Cookies.get("itemsPerPage"):5);
  const [pageNo, setPageNo] = useState(0);
  const [isFetchError, setIsFetchError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [usersData, setUsersData] = useState(null);
  const [rolesData, setRolesData] = useState([]);

  const handleClose = () => setShow(false);

  const setField = (field, value) => {
    if (field === "roleId") {
      setForm({
        ...form,
        roles: [
          {
            roleId: value,
          },
        ],
      });
    } else {
      setForm({
        ...form,
        [field]: value,
      });
    }
  };

  const handleUpdate = async () => {
    let response = await fetchUserById(selectedRow.userId);
    if (response.ok) {
      let data = await response.json();
      if (data != null) {
        setForm(data);
        setValidated(false);
        setShow(true);
        setIsUpdated(false);
        setIsError(false);
      }
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const updateUser = async () => {
    let data = await updateUserRecord(form);
    if (data.userId != null) {
      setIsUpdated(true);
      setSelectedRow(data);
    } else {
      setIsError(true);
    }
  };

  const getUsersData = useCallback(async () => {
    let response = await fetchUsersData(pageNo, recordsPerPage);
    if (response.ok) {
      let data = await response.json();
      if (data.genericList != null) {
        setIsFetchError(false);
        setIsError(false);
        setUsersData(data);
      } else {
        setIsFetchError(true);
        setIsError(true);
      }
    } else {
      let error = await response.json();
      setIsFetchError(true);
      setIsError(true);
      setAlertMessage(error?.description);
    }
  }, [pageNo, recordsPerPage]);

  const getRoles = async () => {
    let response = await fetchRolesData();
    if (response.ok) {
      let data = await response.json();
      if (data?.length > 0) {
        setRolesData(data);
      } else {
        setAlertMessage(data?.description);
      }
    } else {
      let error = await response.json();
      setAlertMessage(error?.description);
    }
  };

  useEffect(() => {
    getUsersData();
  }, [pageNo, recordsPerPage, getUsersData]);

  useEffect(() => {
    getRoles();
  }, []);

  useEffect(() => {
    if (isUpdated) {
      getUsersData();
    }
  }, [isUpdated]);

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        <Button
          className="updateButtonStyle generalFont flexCenter"
          onClick={handleUpdate}
          disabled={selectedRow == null && !isError}
        >
          <img
            src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
            className="buttonIcon"
            alt=""
          ></img>
          Update
        </Button>
      </div>
    );
  };

  const renderBannerMessage = () => {
    if (isUpdated) {
      return "User has been successfully updated!";
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const handleSubmmit = (event) => {
    event.preventDefault();
    setValidated(true);
    if (event.currentTarget.checkValidity() === true) {
      updateUser();
      setShow(false);
    }
  };

  const changeActiveAndDateState = (value) => {
    if (value === "Active") {
      setForm({
        ...form,
        dateActivated: moment().format("yyyy-MM-DD"),
        dateDeActivated: null,
        isActive: true,
      });
    } else {
      setForm({
        ...form,
        dateDeActivated: moment().format("yyyy-MM-DD"),
        dateActivated: null,
        isActive: false,
      });
    }
  };

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">User Role Management</Row>
            <Row className="tableSubtitle generalFont">
              View all the Roles Associated to a User
            </Row>
          </Col>
        </Row>
        {(isUpdated || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsUpdated(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}

        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={userRoleManagementHeadCells}
          rows={usersData?.genericList}
          pages={usersData?.totalPages}
          buttonsLayout={buttonsLayout}
          setSelectedRowCallback={setSelectedRowCallback}
          isUserRoleManagementScreen={true}
        />
      </Container>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Form onSubmit={handleSubmmit} noValidate validated={validated}>
          <Modal.Header className="modalHeaderContainer" closeButton>
            <Modal.Title className="modalHeader generalFont">
              Update Role
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBodyContainer">
            <Row style={{ paddingTop: "40px" }}>
              <Col>
                <Form.Group className="mb-3" controlId="form.name">
                  <React.Fragment>
                    <Form.Label className="modalLabel generalFont">
                      Name
                    </Form.Label>
                  </React.Fragment>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    placeholder="Hint Text"
                    disabled
                    value={`${form.firstName} ${form.lastName}`}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="form.roleName">
                  <Form.Label className="modalLabel generalFont">
                    Role
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    required
                    value={form?.roles?.[0].roleId}
                    onChange={(e) => setField("roleId", e.target.value)}
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    {rolesData
                      .sort((a, b) => (a.roleName > b.roleName ? 1 : -1))
                      .map((entry) => {
                        return (
                          <option key={entry.roleId} value={entry.roleId}>
                            {entry.roleName}
                          </option>
                        );
                      })}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="form.isActive">
                  <Form.Label className="modalLabel generalFont">
                    Status
                  </Form.Label>
                  <Form.Select
                    className="modalInput generalFont"
                    aria-label="Choose Item"
                    required
                    value={handleIsActive(form.isActive)}
                    onChange={(e) => changeActiveAndDateState(e.target.value)}
                  >
                    <option hidden value="">
                      Choose Item
                    </option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>
            <Row style={{ paddingTop: "40px" }}>
              <Col>
                <Form.Group className="mb-3" controlId="dateActivated">
                  <Form.Label className="modalLabel generalFont">
                    Date Activated
                  </Form.Label>
                  <Form.Control
                    disabled
                    className="modalInput generalFont"
                    type="date"
                    value={form.dateActivated != null ? form.dateActivated : ""}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="dateDeActivated">
                  <Form.Label className="modalLabel generalFont">
                    Date Deactivated
                  </Form.Label>
                  <Form.Control
                    disabled
                    className="modalInput generalFont"
                    type="date"
                    value={
                      form.dateDeActivated != null ? form.dateDeActivated : ""
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer className="modalFooterContainer">
            <Button
              type="submit"
              className="modalAddUpdateStyle generalFont flexCenter"
            >
              <img
                src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                alt=""
                style={{ marginRight: "10px" }}
              ></img>
              Update
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default UserRoleManagement;
